import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import { RPE_INTENSITY_COLORS } from "../../../../../constants";

const TOTAL_BARS = 10;

function LogSessionRpeCard({ dailyStat }) {
  const { t } = useTranslation("athlete-portal");
  const sessionRPE = dailyStat?.sessionRPE;

  if (sessionRPE == null || sessionRPE <= 0) return null;
  const rpeColors = [...RPE_INTENSITY_COLORS.slice(0, -1), "var(--rpe-10-color)"];

  const rpeColor = rpeColors[Math.trunc(sessionRPE - 5)] ?? rpeColors[0];
  const filledBars = Math.round((sessionRPE - 5) * 2);

  return (
    <div className="log-card log-card--session-rpe">
      <div className="log-card__header">
        <SvgIcon src="/img/new-icons/barbell.svg" useCurrentColor={true} />
        <span>{t("calendar.cards.sessionRpe.title")}</span>
        <span className="log-card__score-inline" style={{ color: rpeColor }}>
          {sessionRPE}/10
        </span>
      </div>
      <div className="log-card__body">
        <div
          className="session-rpe-bars"
          style={{ "--session-rpe-color": rpeColor }}
        >
          {Array.from({ length: TOTAL_BARS }, (_, i) => (
            <span
              key={i}
              className={`session-rpe-bar${i < filledBars ? " session-rpe-bar--filled" : ""}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default LogSessionRpeCard;
